import { ReactNode } from 'react';
import { usePageTitle } from '../hooks/usePageTitle';

/**
 * Invisible wrapper component that sets the document title.
 * Designed for use inside route definitions so titles are set at the
 * routing layer without modifying individual page components.
 *
 * Usage in routes:
 *   <PageTitle title="Jobs">{suspense(<JobsPage />)}</PageTitle>
 */
export function PageTitle({ title, children }: { title: string; children: ReactNode }) {
  usePageTitle(title);
  return <>{children}</>;
}

export default PageTitle;
